/* SpacePicker.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._0wOv4Q7zJH%7Bcursor%3Apointer%7D%0A._0KLXru7Cj1%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._0jFU0VpJKa%7Bheight%3A3pc%7D%0A._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._0hPERGjOvk%3Ahover%7Bborder-color%3Atransparent%7D%0A._1eOmH6KcZT%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._1eOmH6Y9q9%3Ahover%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._3vBAKHnXvL%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._0KLXruDMqu%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D%0A._0hPERGnXvL%3Ahover%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._1kk5Tk7GSX%7Bfont-weight%3Avar(--ds-font-weight-semibold%2C600)%7D%0A._43nrzTdnbC%7Bmargin-block-start%3A0%7D%0A._0rIjyk1Y8M%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");


















import { Fragment, useCallback, useEffect, useMemo, useRef } from 'react';
import Avatar from '@atlaskit/avatar/avatar';
import { getDocument } from '@atlaskit/browser-apis';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { components } from '@atlaskit/react-select/components';
import type { CSSObjectWithLabel } from '@atlaskit/react-select/types';
import AsyncSelect from '@atlaskit/select/async-select';
import type { ControlProps, OptionType } from '@atlaskit/select/types';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme
import { layers } from '@atlaskit/theme/constants';
import { ApplicationEdition } from '@atlassian/invite-people/types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cx } from '@compiled/react';
import { defineMessage, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';
import { useAnalytics } from '@townsquare/analytics';
import { useSpaceSearch, createSpaceOption, shouldIncludeProject, buildProjectOptions } from '../../hooks/useSpaceSearch';
import { JiraSpaceOption, SpaceSelectOption } from '../../types/SpaceInputTypes';
import type { SpacePicker_data$key, SpacePicker_data$data } from './__generated__/SpacePicker_data.graphql';
export type SpacePickerProps = {
  selectedSpace: JiraSpaceOption | undefined;
  onSelectSpace: (space: JiraSpaceOption | undefined) => void;
  data: SpacePicker_data$key;
  cloudId: string;
  appEdition: ApplicationEdition;
};
const spacePickerSpaceSelectLabelMessage = defineMessage({
  id: 'townsquare.invite-people-modal.space-picker.space-select-label',
  defaultMessage: "Select which Jira space they'll be added to",
  description: 'The label for a dropdown component which allows the user to select the space the invited person will be added to.'
});
const spacePickerNoSpaceOptionsMessage = defineMessage({
  id: 'townsquare.invite-user-modal.space-picker.no-space-options-message',
  defaultMessage: 'There are no Jira spaces that you can add people to. Please check your permissions',
  description: 'The message displayed when no spaces are found in the space picker.'
});
const buildRecommendedOptions = (recommendations: NonNullable<SpacePicker_data$data['smarts']>['recommendedContainerV2'], appEdition: ApplicationEdition): SpaceSelectOption[] => recommendations?.flatMap(rec => {
  const container = rec?.container;
  if (!container?.name || !container.projectId || !container.key) return [];
  const projectStyle = container?.projectStyle;
  if (!shouldIncludeProject(container.projectType, projectStyle, appEdition)) return [];
  return [createSpaceOption({
    projectId: container.projectId,
    key: container.key,
    name: container.name,
    projectType: container.projectType,
    projectStyle: container.projectStyle,
    avatarUrl: container.avatar?.medium,
    source: 'recommendation'
  })];
}) ?? [];
const controlStyles = {
  root: "_0bjKvDKxmn _3vBAKH9r67 _0wOv4Q7zJH _0KLXru7Cj1 _0jFU0VpJKa _0LQT5E8HPE _0hPERGjOvk _1eOmH6KcZT",
  menuIsOpen: "_0KLXruY9q9 _1eOmH6Y9q9",
  focused: "_3vBAKHnXvL _0KLXruDMqu _0hPERGnXvL",
  label: "_2sNsIg7NXe _1kk5Tk7GSX _43nrzTdnbC _0rIjyk1Y8M _3iDTPbvLZJ _1UtDYzKGUX"
};
const formatOptionLabel = (option: OptionType) => {
  const avatar = option.data.avatarUrls?.['24x24'];
  return <Flex gap="space.100">
			<Avatar src={avatar} size="xxsmall" />
			<span>{option.data.name}</span>
		</Flex>;
};
const CustomControl = (props: ControlProps<SpaceSelectOption>) => <components.Control {...props} xcss={cx(controlStyles.root, props.isFocused && controlStyles.focused, props.menuIsOpen && controlStyles.menuIsOpen)} />;
export const SpacePicker = ({
  selectedSpace,
  onSelectSpace,
  data: dataRef,
  cloudId,
  appEdition
}: SpacePickerProps): JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const hasInitialised = useRef(false);
  const analytics = useAnalytics();
  const data = useFragment<SpacePicker_data$key>(graphql`
			fragment SpacePicker_data on Query
			@argumentDefinitions(
				cloudId: { type: "ID!" }
				userId: { type: "String!" }
				tenantId: { type: "String!" }
				first: { type: "Int", defaultValue: 20 }
			) {
				jira {
					allJiraProjects(
						cloudId: $cloudId
						filter: {
							sortBy: { order: DESC, sortBy: LAST_ISSUE_UPDATED_TIME }
							types: [BUSINESS, SOFTWARE]
							keyword: ""
						}
						first: $first
					) {
						edges {
							node {
								projectId
								name
								key
								avatar {
									medium
								}
								projectType
								projectStyle
							}
						}
					}
				}
				smarts {
					recommendedContainerV2(
						recommendationsQuery: {
							context: { userId: $userId, tenantId: $tenantId, product: "jira" }
							modelRequestParams: {
								caller: "team-invite-people"
								experience: "CgContainerNearbyUser"
							}
							requestingUserId: "context"
							maxNumberOfResults: 10
						}
					) {
						container {
							... on JiraProject {
								projectId
								name
								key
								avatar {
									medium
								}
								projectType
								projectStyle
							}
						}
					}
				}
			}
		`, dataRef);
  const options = useMemo(() => {
    const recommendedProjects = buildRecommendedOptions(
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    data.smarts?.recommendedContainerV2, appEdition);
    const excludeIds = new Set(recommendedProjects.map(opt => opt.value));
    const nodes = data.jira?.allJiraProjects?.edges?.map(e => e?.node);
    const allProjectOptions = buildProjectOptions(nodes, appEdition, excludeIds, 'project-list');
    return [...recommendedProjects, ...allProjectOptions].slice(0, 10);
  }, [data.jira?.allJiraProjects?.edges, data.smarts?.recommendedContainerV2, appEdition]);
  const handleChange = useCallback((newValue: SpaceSelectOption | null) => {
    onSelectSpace(newValue ? newValue.data : undefined);
    if (newValue) {
      void analytics.ui('option', 'selected', {
        selectedSpace: newValue.data.key,
        projectType: newValue.data.projectTypeKey,
        source: newValue.data.source,
        appEdition
      }, 'spacePicker');
    } else {
      void analytics.ui('option', 'cleared', {
        appEdition
      }, 'spacePicker');
    }
  }, [onSelectSpace, analytics, appEdition]);
  useEffect(() => {
    if (hasInitialised.current) {
      return;
    }
    hasInitialised.current = true;
    if (options.length > 0) {
      onSelectSpace(options[0].data);
      void analytics.ui('option', 'selected', {
        defaultSelected: true,
        selectedSpace: options[0].data.key,
        projectType: options[0].data.projectTypeKey,
        source: options[0].data.source,
        appEdition
      }, 'spacePicker');
    }
    void analytics.track('spacePicker', 'loaded', {
      recommendedSpaceCount: data.smarts?.recommendedContainerV2?.length ?? 0,
      allSpacesCount: data.jira?.allJiraProjects?.edges?.length ?? 0,
      appEdition
    });
  }, [options, onSelectSpace, analytics, cloudId, data, appEdition]);
  const loadOptions = useSpaceSearch({
    cloudId,
    appEdition,
    defaultOptions: options
  });
  if (options.length === 0 && !hasInitialised.current) {
    return null;
  }
  return <Fragment>
			<label id="space-picker-input-label" className={ax([controlStyles.label])}>
				{formatMessage(spacePickerSpaceSelectLabelMessage)}
			</label>
			<AsyncSelect closeMenuOnSelect isClearable isSearchable loadOptions={loadOptions} defaultOptions={options} value={selectedSpace ? {
      label: selectedSpace.name,
      value: selectedSpace.id,
      data: selectedSpace
    } : null} onChange={handleChange} noOptionsMessage={() => formatMessage(spacePickerNoSpaceOptionsMessage)} components={{
      Control: CustomControl
    }} formatOptionLabel={formatOptionLabel} inputId="space-picker-input" labelId="space-picker-input-label" menuPortalTarget={getDocument()?.body} styles={{
      menuPortal: base => ({
        ...base,
        zIndex: layers.modal()
      } as CSSObjectWithLabel)
    }} />
		</Fragment>;
};